import { render, staticRenderFns } from "./TypeFilter.vue?vue&type=template&id=6ac23d7a&scoped=true&"
import script from "./TypeFilter.vue?vue&type=script&lang=ts&"
export * from "./TypeFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac23d7a",
  null
  
)

export default component.exports